import { createReducer, on } from "@ngrx/store"
import {StoreDataModel } from "../../models/shared/Auth/IUserData.interface"
import { ChangeUserData } from "./AuthAction"
export const initialStat : StoreDataModel = {
userData:{
    appHasTutorial: false,
    branchId: 0,
    companyCode: '',
    companyId: 0,
    email: '',
    employeeId: 0,
    fullName: '',
    imgPath: '',
    isAuthenticated: false,
    jobId: 0,
    refreshToken: '',
    roles: [],
    technician_Id: 0,
    userCode: '',
    userId: '',
    userName: '',
    menu: [],
    holdingCompanyId: 0,
    companyName: "",
    stockCarData: [],
    clientBranchId: 0,
    isClient: false,
    isVendor:false,
    vendorId:0,
    configuration: {
        maintConfig: {
            assetsIsMasterInServiceRequests: false,
            isActive: false,
            locationMeterRange: 0,
            priorityIsChange: false
        }
    }
}


}
export const AuthReducer = createReducer(initialStat,
    on(ChangeUserData, (state , action:any) => { return { ...state, userData: action } }),
)
